import React from 'react';
import logo from '../../assets/logo1.svg'
import sm1 from '../../assets/fb.svg'
import sm2 from '../../assets/ig.svg'
import sm3 from '../../assets/twt.svg'

import './footer.css'
import Button from '../common/button';
const Footer = () => {
    return ( <>
    <div className="container">
        <footer>
            <div className="btnFlex">
                <img src={logo} alt="" />
        <p>© Ma7gouz EGYPT. All Rights Reserved.</p>
            </div>
        <div className="categoriesFlex">
        <Button img={sm1} class=" btn3" />
        <Button img={sm2} class=" btn3" />
        <Button img={sm3} class=" btn3" />

        </div>
        </footer>
    </div>
    
    </> );
}
 
export default Footer;